import cx from 'classnames'
import { ContentProps } from './Types'
import Styles from './Content.module.scss'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const Content = ({
  children,
  fillAvailableSpace,
  className,
  withoutFooter,
  compact = true,
  isConfirmation = false,
}: ContentProps) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const { isMobile } = useResponsiveDesign()

  return (
    <div
      className={cx(Styles.content, className, {
        [Styles.fillAvailableSpace]: fillAvailableSpace,
        [Styles.withoutFooter]: withoutFooter,
        [Styles.compact]: !isMobile && isSystemRedesignEnabled && compact,
        [Styles.isConfirmation]: isConfirmation,
      })}
    >
      {children}
    </div>
  )
}
